module.exports = __webpack_public_path__ + "static/img/navbar_logo.06db58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/navbar_logo.png
// module id = BTxe
// module chunks = 1